import {
  REGENERATE_INVOICE_FAILURE,
  REGENERATE_INVOICE_REQUEST,
  REGENERATE_INVOICE_RESET,
  REGENERATE_INVOICE_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const regenerateInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGENERATE_INVOICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case REGENERATE_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case REGENERATE_INVOICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case REGENERATE_INVOICE_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default regenerateInvoiceReducer
